import React from "react";
import { SkillsInfo } from "../constants";
import Tilt from "react-parallax-tilt";

const Skills = () => (
  <section
    id="skills"
    className="py-28 px-[6vw] md:px-[8vw] lg:px-[15vw] relative bg-gradient-to-b from-[#050414] via-[#0b0724] to-[#050414]"
  >
    {/* Section Title */}
    <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
      <h2 className="text-xs uppercase tracking-[0.3em] font-bold text-[#8245ec]">Core Competencies</h2>
      <h3 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight">Technical</h3>
      <div className="w-24 h-1.5 bg-gradient-to-r from-[#8245ec] to-purple-400 mx-auto rounded-full"></div>
      <p className="text-gray-400 text-base sm:text-lg">
        Architecting robust, maintainable, and high-performance digital products utilizing modern frameworks and enterprise tools.
      </p>
    </div>

    {/* Skill Categories Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {SkillsInfo.map((category) => (
        <div
          key={category.title}
          className="bg-white/[0.02] backdrop-blur-xl p-8 rounded-3xl border border-white/10 shadow-[0_8px_32px_0_rgba(0,0,0,0.37)] hover:border-purple-500/40 transition-all duration-500 group"
        >
          <h4 className="text-2xl font-bold text-white mb-6 flex items-center justify-between">
            <span>{category.title}</span>
            <span className="text-xs font-mono text-[#8245ec] bg-purple-950/60 px-3 py-1 rounded-full border border-purple-500/20">
              {category.skills.length} Tech
            </span>
          </h4>

          <Tilt
            key={category.title}
            tiltMaxAngleX={10}
            tiltMaxAngleY={10}
            perspective={1000}
            scale={1.02}
            transitionSpeed={800}
            gyroscope={true}
          >
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {category.skills.map((skill) => (
                <div
                  key={skill.name}
                  className="flex items-center space-x-3 bg-white/[0.03] hover:bg-white/[0.07] border border-white/5 hover:border-[#8245ec]/40 rounded-2xl p-3.5 transition-all duration-300 cursor-pointer group/item"
                >
                  <img
                    src={skill.logo}
                    alt={`${skill.name} logo`}
                    className="w-7 h-7 sm:w-8 sm:h-8 object-contain transform group-hover/item:scale-110 transition-transform duration-300"
                  />
                  <span className="text-xs sm:text-sm font-medium text-gray-300 group-hover/item:text-white">
                    {skill.name}
                  </span>
                </div>
              ))}
            </div>
          </Tilt>
        </div>
      ))}
    </div>
  </section>
);

export default Skills;